export const ALLOWED_AUDIO_MIME_TYPES = [
  'audio/mp4',
  'audio/mpeg',
  'audio/webm',
  'audio/aac',
  'audio/x-m4a',
  'audio/wav',
  'audio/ogg',
  'audio/flac',
] as const;

export const ALLOWED_DOCUMENT_MIME_TYPES = [
  // Images
  'image/jpeg',
  'image/jpg',
  'image/png',
  'image/gif',
  'image/webp',
  'image/svg+xml',
  'image/bmp',
  // Documents
  'application/pdf',
  // Videos
  'video/webm',
  'video/avi',
  'video/mp4',
  'video/quicktime',
  'video/x-msvideo',
] as const;

export const ALLOWED_MIME_TYPES = [
  ...ALLOWED_DOCUMENT_MIME_TYPES,
  ...ALLOWED_AUDIO_MIME_TYPES,
] as const;

export const MAX_FILE_SIZE = 50 * 1024 * 1024; // 50 MB
export const MAX_FILES_PER_REQUEST = 10;

export type AllowedMimeType = (typeof ALLOWED_MIME_TYPES)[number];
export type AllowedAudioMimeType = (typeof ALLOWED_AUDIO_MIME_TYPES)[number];
export type AllowedDocumentMimeType =
  (typeof ALLOWED_DOCUMENT_MIME_TYPES)[number];
